import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as ticketsActions from '../../redux/tickets/actions';
import TicketsTable from './ticketsTable';
import Spin from '../../components/loading';
import Pagination2 from '../../components/Pagination2';
import TicketsFilter from './ticketsFilter';
import submitForm from '../../utils/submitForm';

class Tickets extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      sortType: 'asc',
      sortBy: 'lastUpdatedAt',
      itemsPerPage: 10
    };
  }

  componentDidMount() {
    this.sortTable(this.state.sortBy);
  }

  sortTable = query => {
    this.setState({ sortType: this.state.sortType == 'asc' ? 'desc' : 'asc' }, () => {
      query = `${query}-${this.state.sortType}`;
      this.setState({ sort: `sort=${query}` }, () => this.filterAndSort());
    });
  };

  applyFilters = event => {
    const queryString = submitForm(event, this.state.selectedRegions, this.state.selectedAmenities);
    this.setState({ filter: queryString }, () => this.filterAndSort());
  };

  filterAndSort = () => {
    let { filter, sort } = this.state;
    let query;
    if (sort && filter) query = `${filter}&${sort}`;
    else if (filter) query = `${filter}`;
    else if (sort) query = `${sort}`;
    this.setState({ query, currentPage: 1 }, () => {
      let searchQuery = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.fetchAllTickets(searchQuery);
    });
  };

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  onPageChanged = data => {
    const { currentPage, totalPages, pageLimit } = data;
    this.setState({ currentPage: currentPage }, () => {
      const query = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.fetchAllTickets(query);
    });
  };
  render() {
    let { ticketsLoading, ticketsMessage, ticketsFailed, ticketsError } = this.props;
    let { totalRecords } = this.props.tickets;
    let { currentPage, itemsPerPage, sortType } = this.state;
    return (
      <>
        <div className="col-12 d-flex justify-content-between align-items-center">
          <h3 className="text-right text-muted py-4">
            <div className="text-right">{locales('titles.ticketsManagement')}</div>
          </h3>
        </div>
        <section className="p-1 col-12">
          <Spin spinning={ticketsLoading}>
            <article>
              <main className="panel panel-default">
                {ticketsError ? (
                  <div className="alert alert-danger">{locales('messages.server.error')}</div>
                ) : (
                  <>
                    {ticketsFailed && <div className="alert alert-danger">{ticketsMessage}</div>}
                    <div className="panel-heading">
                      <i className="fas fa-list-alt px-1" />
                      {locales('titles.ticketsList')}
                    </div>
                    <div className="panel-body">
                      <TicketsFilter applyFilters={this.applyFilters} filterAndSort={this.filterAndSort} />
                      <TicketsTable
                        pageNumber={currentPage}
                        sortTable={this.sortTable}
                        pageSize={itemsPerPage}
                        sortType={sortType}
                      />
                      <footer className="col-12 d-flex justify-content-center py-2">
                        <div className="pagination-container">
                          <Pagination2
                            totalRecords={totalRecords || 0}
                            pageLimit={itemsPerPage}
                            pageNeighbours={2}
                            onPageChanged={this.onPageChanged}
                            currentPage={this.state.currentPage}
                          />
                        </div>
                      </footer>
                    </div>
                  </>
                )}
              </main>
            </article>
          </Spin>
        </section>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    ticketsList: state.ticketsReducer.ticketsList,
    tickets: state.ticketsReducer.tickets,
    ticketsLoading: state.ticketsReducer.ticketsLoading,
    ticketsMessage: state.ticketsReducer.ticketsMessage,
    ticketsFailed: state.ticketsReducer.ticketsFailed,
    ticketsError: state.ticketsReducer.ticketsError
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchAllTickets: query => dispatch(ticketsActions.fetchAllTickets(query))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Tickets));
